// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2145":"69c11d6f","3802":"1eb8d544","7746":"1eb8d544"}[chunkId] + ".chunk.css";
};